/* eslint-disable @typescript-eslint/naming-convention */
import { type SizeType } from 'antd/es/config-provider/SizeContext';
// import colors from 'core/constants/colors';
import theme from 'core/theme/theme.config';

const viewportWidth = window.innerWidth;
const colors = theme.palette;
const px = (rem: string) => parseFloat(rem) * 16;
const ConfigStyle = {
  theme: {
    token: {
      fontFamily: theme.brand.fontFamily,
      fontSize: px(theme.fontSize.base),
      colorBgBase: colors['neutral-10'],
      colorBgContainer: colors['neutral-10'],
      colorBorder: colors['neutral-60'],
      colorBgContainerDisabled: colors['neutral-40'],
      colorSuccess: colors['success-500'],
      colorError: colors['danger-500'],
      colorPrimary: colors['primary-700'],
      colorPrimaryHover: colors['primary-500'],
      colorTextDisabled: colors['neutral-100'],
      colorTextPlaceholder: colors['neutral-300'],
      colorLink: colors['primary-700'],
      colorText: colors['neutral-700'],
    },
    components: {
      Button: {
        borderRadius: 4,
        contentFontSize: px(theme.fontSize.sm),
        primaryShadow: 'none',
        defaultShadow: 'none',
      },
      Layout: {
        headerColor: colors['primary-700'],
        bodyBg: colors['neutral-30'],
      },
      Tooltip: {
        colorText: colors['neutral-500'],
        colorBgSpotlight: colors['neutral-10'],
      },
      Table: {
        colorTextHeading: colors['neutral-300'],
        headerBg: colors['neutral-30'],
        cellFontSize: px(theme.fontSize.sm),
        rowHoverBg: colors['neutral-30'],
        borderColor: colors['neutral-40'],
        borderRadius: 58,
        padding: 10,
      },
      ...(viewportWidth > 900 && {
        Menu: {
          subMenuItemBg: colors['neutral-10'],
          itemSelectedColor: colors['neutral-10'],
          itemSelectedBg: colors['primary-700'],
          itemBg: colors['neutral-10'],
          itemColor: colors['neutral-500'],
          itemHoverColor: colors['neutral-500'],
          itemHoverBg: colors['primary-50'],
          itemActiveBg: colors['primary-700'],
        },
      }),
      Input: {
        activeBorderColor: colors['primary-700'],
        colorText: colors['neutral-800'],
        colorBorderSuccess: colors['success-500'],
      },
      Checkbox: {
        colorPrimary: colors['primary-700'],
      },
      Select: {
        selectorBg: colors['neutral-20'],
        colorBorder: colors['neutral-60'],
        optionSelectedFontWeight: 400,
        colorBgElevated: colors['neutral-10'],
        optionSelectedBg: colors['neutral-10'],
        optionSelectedColor: colors['primary-700'],
        optionSelectedBorderColor: colors['primary-100'],
        optionActiveBg: colors['primary-50'],
        optionFontSize: px(theme.fontSize.base),
      },
      DatePicker: {
        colorText: colors['neutral-800'],
        colorTextDisabled: colors['neutral-80'],
        colorPrimary: colors['primary-700'],
      },
      Typography: {
        colorTextHeading: colors['neutral-600'],
      },
      Tree: {},
      Segmented: {
        itemSelectedBg: colors['primary-700'],
        itemSelectedColor: colors['neutral-10'],
        trackBg: colors['neutral-50'],
      },
    },
  },

  componentSize: 'large' as SizeType,
  labelfontWeight: '500',
  labelColor: colors['neutral-700'],
  labelfontSize: 'var(--font-sm)',
  colors,
  contentProps: {
    className: 'custom-form',
    bordered: false,
  },
};

export default ConfigStyle;
